class ProductCardSwatches extends HTMLElement {
  #productDataCache = null;

  connectedCallback() {
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  #onClick = (e) => {
    const swatch = e.target.closest('[data-href]');
    if (swatch) {
      e.preventDefault();
      e.stopPropagation();
      this.#syncQuickAddVariantFromUrl(swatch.dataset.href);

      if (this.dataset.updateMediaOnSwatch === 'true') {
        this.#updateCheckedState(swatch);
        this.#updateProductCardMedia(swatch.dataset.href);
        return;
      }

      window.location.href = swatch.dataset.href;
    }
  };

  #syncQuickAddVariantFromUrl(variantUrl) {
    try {
      const absoluteUrl = new URL(variantUrl, window.location.origin);
      const variantId = absoluteUrl.searchParams.get('variant');
      if (!variantId) return;

      const productCard = this.closest('product-card');
      if (!productCard) return;

      const addToCartButton = productCard.querySelector('[data-ref="add-to-cart-button"]');
      const popupToggle = productCard.querySelector('[data-ref="popup-toggle"]');

      if (addToCartButton) addToCartButton.dataset.variantId = variantId;
      if (popupToggle) popupToggle.dataset.variantId = variantId;
    } catch (error) {
      console.error('Error while syncing swatch variant to quick add:', error);
    }
  }

  #updateCheckedState(selectedSwatch) {
    this.querySelectorAll('.swatch-link[aria-checked="true"]').forEach((swatch) => {
      swatch.removeAttribute('aria-checked');
    });
    selectedSwatch.setAttribute('aria-checked', 'true');
  }

  async #updateProductCardMedia(variantUrl) {
    try {
      const absoluteUrl = new URL(variantUrl, window.location.origin);
      const variantId = absoluteUrl.searchParams.get('variant');
      if (!variantId) return;

      const productHandle = this.#getProductHandleFromUrl(absoluteUrl.pathname);
      if (!productHandle) return;

      const productData = await this.#getProductData(productHandle);
      if (!productData) return;

      const variant = productData.variants.find((item) => item.id === parseInt(variantId, 10));
      const variantImage = variant?.featured_image?.src || productData.featured_image;
      if (!variantImage) return;

      const productCard = this.closest('product-card');
      if (!productCard) return;

      const featuredMediaContainer = productCard.querySelector('[data-ref="product-card-featured-media"]');
      if (!featuredMediaContainer) return;

      const mainImage = featuredMediaContainer.querySelector('img');
      if (!mainImage) return;

      const imageUrl = this.#buildImageUrl(variantImage);
      mainImage.src = imageUrl;
      mainImage.srcset = '';
      mainImage.removeAttribute('sizes');
    } catch (error) {
      console.error('Error while updating product card media from swatch:', error);
    }
  }

  #getProductHandleFromUrl(pathname) {
    const parts = pathname.split('/').filter(Boolean);
    const productsIndex = parts.indexOf('products');
    if (productsIndex === -1) return null;
    return parts[productsIndex + 1] || null;
  }

  async #getProductData(productHandle) {
    if (this.#productDataCache?.handle === productHandle) {
      return this.#productDataCache.data;
    }

    const response = await fetch(`/products/${productHandle}.js`);
    if (!response.ok) return null;

    const data = await response.json();
    this.#productDataCache = { handle: productHandle, data };
    return data;
  }

  #buildImageUrl(imageUrl) {
    if (!imageUrl) return imageUrl;
    if (imageUrl.includes('?')) {
      return `${imageUrl}&width=1200`;
    }
    return `${imageUrl}?width=1200`;
  }
}

if (!customElements.get('product-card-swatches')) {
  customElements.define('product-card-swatches', ProductCardSwatches);
}